/**
 * @docsPrivate
 *
 * @description
 *
 * Enum para definiÃ§Ã£o do tipo de conteÃºdo exibido na modal.
 */
export enum ThfModalPasswordRecoveryModalContent {

  /** ExibiÃ§Ã£o de modal contendo campo para preenchimento de email ou nÃºmero de telefone */
  Email = 'email',

  /** ExibiÃ§Ã£o de modal contendo campo para inserÃ§Ã£o de cÃ³digo enviado por SMS */
  SMSCode = 'smsCode',

  /** ExibiÃ§Ã£o de modal de confirmaÃ§Ã£o de envio */
  Confirmation = 'confirmation'

}
